
export const  SET_LOCALIZATION_MESSAGES  = 'SET_LOCALIZATION_MESSAGES';

export function setLocalizationMessages(messages,locale) {
  return {
    type: SET_LOCALIZATION_MESSAGES,
    messages,
    locale
  };
}